module.exports = __webpack_public_path__ + "static/media/sbf-website-view-0.717205e8.png";